"use client";
import { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { useTranslations } from 'next-intl';
import { gsap } from "gsap";

const services = [
    {
        title: "tech_strategy",
        description: "tech_strategy_desc",
    },
    {
        title: "ui_ux_design",
        description: "ui_ux_design_desc",
    },
    {
        title: "development",
        description: "development_desc",
    },
    {
        title: "ai_data_solutions",
        description: "ai_data_solutions_desc",
    },
    {
        title: "cypersecurity_qa",
        description: "cypersecurity_qa_desc",
    },
    {
        title: "digital_growth",
        description: "digital_growth_desc",
    }
];

export default function Services() {
    const t = useTranslations('Home');
    const title = t('services_offering_title');
    const words = title.split(" ");

    return (
        <section className="py-20 px-5 md:px-20 bg-menu-list" id="what-we-do">
            {/* Section Title */}
            <div className="mx-auto text-start mb-16 flex flex-col md:flex-row justify-between items-center">
                <h2 className="text-4xl md:text-6xl font-bold mb-4 max-w-[500px] capitalize text-white">
                    {words[0]}{" "}
                    <span className="color-primary">{words[1]}</span>{" "}
                    {words.slice(2).join(" ")}
                </h2>
            </div>

            {/* Services List */}
            <div className="space-y-8 mx-auto">
                {services.map((service, idx) => (
                    <div
                        key={idx}
                        className="group relative border-b border-slate-500 pb-6 cursor-pointer"
                    >
                        {/* Row */}
                        <div className="flex flex-col md:flex-row justify-between items-center group">
                            <div>
                                <h3 className="text-2xl md:text-4xl lg:text-5xl font-regular opacity-70 group-hover:opacity-100 text-white">
                                    {t(service.title)}
                                </h3>

                                <p className="text-white max-w-2xl mt-4
                                    opacity-100 md:opacity-0 translate-y-2 transition-all duration-300
                                    group-hover:opacity-100 group-hover:translate-y-0">
                                    {t(service.description)}
                                </p>
                            </div>

                            <ArrowRight
                                className="text-white w-10 h-10 border-1 rounded-full px-2 hidden md:block 
                                    opacity-100 transition-all duration-300 
                                    group-hover:opacity-0 group-hover:translate-x-2"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
